const DEFAULT_FA = "fas fa-magic";

/** Nomes lógicos (protótipo / automação) → Font Awesome 5 */
export const LOGICAL_ICON_TO_FA = {
  sparkles: "fas fa-magic",
  zap: "fas fa-bolt",
  truck: "fas fa-truck",
  trendingup: "fas fa-chart-line",
  tag: "fas fa-tag",
  shield: "fas fa-shield-alt",
  package: "fas fa-box",
  bell: "fas fa-bell",
  dollarsign: "fas fa-dollar-sign",
  ticket: "fas fa-ticket-alt",
  clock: "fas fa-clock",
  layers: "fas fa-layer-group",
  rocket: "fas fa-rocket",
  check: "fas fa-check-circle",
  filetext: "fas fa-file-alt",
  search: "fas fa-search",
  cart: "fas fa-shopping-cart",
  image: "fas fa-image",
  users: "fas fa-users"
};

function normalizeLogicalKey(iconName) {
  return String(iconName)
    .toLowerCase()
    .replace(/[^a-z0-9]/g, "");
}

function isFontAwesomeClass(iconName) {
  return /\bfa[srb]?\s+fa-/.test(iconName) || iconName.includes("fa-");
}

/**
 * @param {string} [iconName]
 * @returns {{ kind: 'fa', class: string }}
 */
export function resolveNovidadeIcon(iconName) {
  if (!iconName || !String(iconName).trim()) {
    return { kind: "fa", class: DEFAULT_FA };
  }
  const trimmed = String(iconName).trim();
  if (isFontAwesomeClass(trimmed)) {
    const cls = trimmed.includes("fas ") || trimmed.includes("far ") || trimmed.includes("fab ")
      ? trimmed
      : `fas ${trimmed.replace(/^\s+/, "")}`;
    return { kind: "fa", class: cls.replace(/\s+/g, " ").trim() };
  }
  const key = normalizeLogicalKey(trimmed);
  const faClass = LOGICAL_ICON_TO_FA[key] || DEFAULT_FA;
  return { kind: "fa", class: faClass };
}

/** Alias alinhado ao naming do discovery */
export const mapIconToDisplay = resolveNovidadeIcon;
